import { useEffect, useMemo } from 'preact/hooks';
import type { LogClient, LogDescriptor } from '../../core/log/client';
import { getClient } from '../state/clients';
import { ensureRegistry, registry, registryState } from '../state/logs';

/** Resolves the log addressed by route params (`/logs/:op/:log`, or a legacy `:id`) and hands back its client. */
export function useLogClient(params: { op?: string; log?: string; id?: string }): { log?: LogDescriptor; client?: LogClient; error?: unknown; loading: boolean } {
  useEffect(() => {
    void ensureRegistry();
  }, []);
  const st = registryState.value;
  const reg = registry.value;
  const log = params.op !== undefined && params.log !== undefined ? reg.byPath(params.op, params.log) : params.id !== undefined ? reg.byIdPrefix(params.id) : undefined;
  return useMemo(() => {
    if (!log) return { loading: st.status === 'loading' || st.status === 'idle' };
    try {
      return { log, client: getClient(log), loading: false };
    } catch (error) {
      return { log, error, loading: false };
    }
  }, [log, st.status]);
}
